<article>
  <div *ngIf="type !== 'minimal'" class="aspect-ratio-75" role="none"></div>
  <div *ngIf="type === 'minimal'" class="aspect-ratio-50" role="none"></div>

  <div class="thumbnail" role="article">
    <figure class="lib-elevation-1" lazy-load-images (click)="viewListing()">
      <ngx-picture
        class="cover"
        *ngIf="data?.source_data?.image_url"
        [src]="data?.source_data?.image_url"
        [lazyLoad]="true">
      </ngx-picture>

      <nav class="lib-nav value">
        <div class="flex flex-wrap flex-1 self-start">
          <lib-price-category
            *ngIf="data?.category"
            class="thumb-badge"
            [metadata]="data?.metadata"
            [category]="data?.category">
          </lib-price-category>
          <span *ngIf="isRecommended" class="lib-spacer-fixed"></span>
          <div *ngIf="isRecommended" class="lib-badge thumb-badge bg-yellow text-black">
            <lib-icon name="cursor" class="text-black"></lib-icon>
            Picked by our experts
          </div>

        </div>
        <span class="lib-spacer"></span>
        <h4>{{!!data?.metadata?.price ? (data?.metadata?.price | shortNumber) : ''}}</h4>
      </nav>

      <nav *ngIf="toggle.isInfoModeActive" class="lib-nav back-overlay">
      </nav>

      <nav *ngIf="toggle.isInfoModeActive" class="lib-nav info-details">
        <div>
          <h5>{{data?.source_data?.displayable_address || data?.source_data?.address}}</h5>
          
          <ul>
            <li [hidden]="data?.metadata?.num_bedrooms == undefined">
              <p class="lib-legend">{{data?.metadata?.num_bedrooms | bedroomCanonical}}</p>
            </li>
            <p [hidden]="data?.metadata?.num_bedrooms == undefined">&middot;</p>
            <li [hidden]="data?.metadata?.property_type == undefined">
              <p class="lib-legend">{{data?.metadata?.property_type | propertyTypeCanonical}}</p>
            </li>
            <p [hidden]="data?.metadata?.property_type == undefined">&middot;</p>
            <li [hidden]="data?.metadata?.surface_area?.sqm == undefined">
              <p class="lib-legend">{{data?.metadata?.surface_area?.sqm | unitConvert}}</p>
            </li>
          </ul>
        </div>
      </nav>

      <nav class="lib-nav action" *ngIf="!toggle.isInfoModeActive">
        <button  *ngIf="toggle.isDislike"
          class="lib-button-reverse"
          (click)="thumbDownClicked($event)">
          <lib-icon name="thumb-down"></lib-icon>
        </button>

        <span class="lib-spacer" *ngIf="toggle.isInfo"></span>
        
        <button *ngIf="toggle.isInfo"
          class="lib-button-reverse"
          (click)="$event.stopImmediatePropagation(); toggle.isInfoModeActive = true">
          <lib-icon name="info"></lib-icon>
        </button>
        
        <span class="lib-spacer"></span>

        <button *ngIf="toggle.isHeart"
          class="lib-button-reverse favourite"
          [class.active]="isFavourite || toggle.isHeartActive"
          placement="left"
          hide-delay="0"
          hideDelayAfterClick="0"
          (click)="thumbnailAction($event)"
          title="Add to favourites"
          pTrackEvent="click" pTrackAction="add_favourite" pTrackCategory="app_home_thumbnail"
        >
          <lib-icon class="favourite" name="heart"></lib-icon>
        </button>
        <button *ngIf="toggle.isPlus"
          class="lib-button-flat"
          placement="left"
          hide-delay="0"
          hideDelayAfterClick="0"
          (click)="thumbnailAction($event)"
        >
          <lib-icon name="plus"></lib-icon>
        </button>
      </nav>

      <nav class="lib-nav action view-listing" *ngIf="toggle.isInfoModeActive">
        <lib-button theme="stroked" (click)="viewListing()">
          View listing
        </lib-button>
        <span class="lib-spacer"></span>
        <button class="lib-button-reverse"
          (click)="$event.stopImmediatePropagation(); toggle.isInfoModeActive = false">
          <lib-icon name="close"></lib-icon>
        </button>
      </nav>
    </figure>

    <nav *ngIf="toggle.isDetails">
      <ul>
        <li [hidden]="data?.metadata?.num_bedrooms == undefined">
          <p class="lib-legend">{{data?.metadata?.num_bedrooms | bedroomCanonical}}</p>
        </li>
        <p [hidden]="data?.metadata?.num_bedrooms == undefined">&middot;</p>
        <li [hidden]="data?.metadata?.property_type == undefined">
          <p class="lib-legend">{{data?.metadata?.property_type | propertyTypeCanonical}}</p>
        </li>
        <p [hidden]="data?.metadata?.property_type == undefined">&middot;</p>
        <li [hidden]="data?.metadata?.surface_area?.sqm == undefined">
          <p class="lib-legend">{{data?.metadata?.surface_area?.sqm | unitConvert}}</p>
        </li>
        <p *ngIf="data?.metadata?.train_stations?.length > 0">&middot;</p>
        <li *ngIf="data?.metadata?.train_stations?.length > 0">
          <p class="lib-legend">
            {{data.metadata.train_stations[0].distance | unitConvert : '' : ' M' : 'miles' }} to {{data.metadata.train_stations[0].station}}
          </p>
        </li>
      </ul>
      <h6>{{data?.source_data?.displayable_address || data?.source_data?.address}}</h6>
      <ul [hidden]="!data?.metadata?.price_change_since_listed">
        <li>
          <p class="lib-legend">
            <span
              [hidden]="!data?.metadata?.price_change_since_listed || data?.metadata?.price_change_since_listed >= 0">Discounted
              {{-data?.metadata?.price_change_since_listed | shortNumber}} since first listed
              {{data?.createdAt | date : 'MMM y'}}</span>
            <span [hidden]="data?.metadata?.price_change_since_listed && data?.metadata?.price_change_since_listed < 0">
              First listed {{data?.createdAt | date : 'MMM y'}}</span>
          </p>
        </li>
      </ul>
    </nav>

    <div class="lib-nav" *ngIf="toggle.isOffset">
      <button [ngClass]="data?.metadata?.price_offset > 0 ? 'lib-button-flat-primary' : 'lib-button-flat-warn' ">
        <span>Offset {{data?.metadata?.price_offset | percent: '1.2-2'}}</span>
      </button>
      <span class="lib-spacer"></span>
      <button [ngClass]="data?.metadata?.ppsqm_forecast > 0 ? 'lib-button-flat-primary' : 'lib-button-flat-warn' ">
        <span>Potent {{data?.metadata?.ppsqm_forecast | percent: '1.2-2'}}</span>
      </button>
    </div>
  </div>
</article>